(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-transportbox-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tp-transportbox-details')) {
    class TpTransportboxDetails extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const configElement = this.querySelector('[data-tp-box-config]');
        if (!configElement) return;

        try {
          this.config = JSON.parse(configElement.textContent);
        } catch (error) {
          this.hidden = true;
          return;
        }

        this.boxes = new Map(
          this.config.variants.map(function(box) {
            return [String(box.variantId), box];
          })
        );
        this.locale = this.config.locale || 'de';
        this.handlePotentialChange = this.handlePotentialChange.bind(this);
        this.abortController = new AbortController();

        ['change', 'click', 'variant:update', 'variant:change', 'product:variant-change'].forEach((eventName) => {
          document.addEventListener(eventName, this.handlePotentialChange, {
            capture: true,
            signal: this.abortController.signal
          });
        });

        const scope = this.closest('section') || this.parentElement;
        if (scope) {
          this.handleMutations = this.handleMutations.bind(this);
          this.observer = new MutationObserver(this.handleMutations);
          this.observer.observe(scope, { childList: true, subtree: true });
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.observer) this.observer.disconnect();
        // Desktop-Layout versetzt dasselbe Element. Bei erneutem Connect
        // Eventhandler und Variantenanzeige wieder aktivieren.
        delete this.dataset.initialized;
      }

      handlePotentialChange(event) {
        const eventVariantId = event && event.detail && (
          (event.detail.variant && event.detail.variant.id) ||
          (event.detail.resource && event.detail.resource.id)
        );

        if (eventVariantId) this.update(String(eventVariantId));

        const selectedOption = event && event.target && event.target.value;
        if (selectedOption) {
          const matchedVariant = this.config.variants.find(function(variant) {
            return Array.isArray(variant.options) && variant.options.includes(selectedOption);
          });
          if (matchedVariant) this.update(String(matchedVariant.variantId));
        }

        [0, 80, 240, 700, 1500, 2400].forEach((delay) => {
          window.setTimeout(() => this.update(), delay);
        });
      }

      handleMutations(mutations) {
        const hasExternalChange = mutations.some((mutation) => !this.contains(mutation.target));
        if (hasExternalChange) this.handlePotentialChange();
      }

      resolveVariantId() {
        // Variantenauswahl bleibt im Kaufbereich, auch wenn die Transportbox
        // in die Logistikzeile unter dem Produktgrid verschoben wurde.
        const scope = this.closest('.product-information') || this.closest('section') || document;
        const selectedOptionValues = Array.from(
          scope.querySelectorAll('input[type="radio"]:checked, select[name*="option"]')
        )
          .map((control) => control.value)
          .filter(Boolean);

        if (selectedOptionValues.length > 0) {
          const selectedVariant = this.config.variants.find(function(variant) {
            return Array.isArray(variant.options) &&
              selectedOptionValues.every((value) => variant.options.includes(value));
          });
          if (selectedVariant) return String(selectedVariant.variantId);
        }

        const variantInputs = scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
        for (const input of variantInputs) {
          if (input.value && this.boxes.has(String(input.value))) return String(input.value);
        }

        const urlVariantId = new URL(window.location.href).searchParams.get('variant');
        if (urlVariantId && this.boxes.has(String(urlVariantId))) return String(urlVariantId);

        return String(this.config.selectedVariantId || '');
      }

      formatNumber(value, maximumFractionDigits) {
        const number = Number(value);
        if (!Number.isFinite(number)) return '';

        return new Intl.NumberFormat(this.locale, {
          maximumFractionDigits: maximumFractionDigits
        }).format(number);
      }

      formatDimensions(values) {
        return values
          .map((value) => this.formatNumber(Number(value) / 10, 1))
          .join(' × ') + ' cm';
      }

      update(forcedVariantId) {
        if (!this.boxes) return;

        const variantId = forcedVariantId || this.resolveVariantId();
        const box = this.boxes.get(String(variantId));

        if (!box) {
          this.hidden = true;
          return;
        }

        this.querySelector('[data-tp-box-name]').textContent = box.name;
        this.querySelector('[data-tp-box-outer]').textContent = this.formatDimensions(box.outer);
        this.querySelector('[data-tp-box-inner]').textContent = this.formatDimensions(box.inner);
        this.hidden = false;
      }
    }

    customElements.define('tp-transportbox-details', TpTransportboxDetails);
  }
  } catch(e) { console.error(e); }
})();

})();
